<div *ngIf="!fieldTemplate; else customTemplate" [id]="field.field + '_Item'" class="inputItem">
    <mat-form-field appearance="fill"
                    [color]="field.color" #item [style.z-index]="index">
        <mat-label [class]="field.field + '_Label'">{{field.label | translate}}</mat-label>
        <input autocomplete="off" matInput [id]="field.field" type="text" [formControl]="inputFormControl" [readonly]="field.readonly"
               [autoClear]="false" [inputMask]="field.mask" [name]="field.label | translate"
               slotChar="{{field.maskSlotChar}}" [defs]="field.maskDefs" [unmask]="field.unmask"
               (focus)="focus.emit($event); openAutocomplete()"
               (click)="openAutocomplete()"
               (focusin)="focusin.emit($event)"
               (focusout)="focusout.emit($event);"
               (blur)="blur.emit($event);">
        <div matSuffix class="matSuffix">
            <button *ngIf="field.withClearButton" type="button" tabindex="-1" mat-icon-button (click)="$event.stopPropagation(); inputFormControl.patchValue('')">
                <mat-icon>close</mat-icon>
            </button>
            <mat-generic-input-slot [control]="inputFormControl" [field]="field" [fieldAddonTemplates]="fieldAddonTemplates$ | async"></mat-generic-input-slot>
        </div>
        <mat-error *ngIf="!(field.selectSearchData?.selectData?.options | async)?.length">
            <mat-generic-input-hint type="error" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
        </mat-error>
        <mat-hint>
            <mat-generic-input-hint type="combined" [control]="inputFormControl" [field]="field" [item]="item"></mat-generic-input-hint>
        </mat-hint>
    </mat-form-field>
    <mat-form-field *ngIf="field.selectSearchData" appearance="fill" class="mask-autocomplete">
        <mat-label>{{ field.label | translate }}</mat-label>
        <input [matAutocomplete]="autoMask" matInput
               (focusin)="$event.stopImmediatePropagation();"
               (input)="$event.stopImmediatePropagation();"
               (focusout)="$event.stopImmediatePropagation();"
               (blur)="$event.stopImmediatePropagation();"
               (click)="$event.stopImmediatePropagation();" [formControl]="inputFormControl" >
        <mat-autocomplete #autoMask="matAutocomplete" [class]="field.field + '_List'" class="info selectSearchData" [displayWith]="displayWith(field, inputFormControl)">
            <mat-option *ngFor="let option of field.selectSearchData?.selectData?.options | async" [value]="option" class="select-search-option"
                        (mouseup)="$event.preventDefault(); $event.stopImmediatePropagation(); selectAutocompleteValue(option)">
                {{ field.selectSearchData?.selectData | matGenericInputLabel : option : true }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-progress-bar class="loading" color="warning" mode="indeterminate"
                      *ngIf="(inputFormControl?.statusChanges | async) === 'PENDING' || inputFormControl?.status === 'PENDING'"></mat-progress-bar>
</div>

<ng-template #customTemplate>
    <ng-container *ngTemplateOutlet="fieldTemplate.template, context: { $implicit: field, genericInput: this, formControl: inputFormControl, index: index }"></ng-container>
</ng-template>
